import { render, staticRenderFns } from "./HeaderPf.vue?vue&type=template&id=70f4c8c4&scoped=true&"
import script from "./HeaderPf.vue?vue&type=script&lang=js&"
export * from "./HeaderPf.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPf.vue?vue&type=style&index=0&id=70f4c8c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f4c8c4",
  null
  
)

export default component.exports